import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Announcement from '../components/announcement'
import Footer from '../components/footer'
import './founders.css'

const Founders = (props) => {
  return (
    <div className="founders-container10">
      <Helmet>
        <title>Founders - @Romania NGO</title>
        <meta
          name="description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta property="og:title" content="Founders - @Romania NGO" />
        <meta
          property="og:description"
          content="Democratizing tourism by changing the way we plan, book and travel."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/262a7285-ee36-4827-90cf-bff2da51d3e3/e678668e-577d-45ce-9b60-b935d207ee1c?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/founders"
        />
        <meta
          property="og:url"
          content="https://copy-of-romania-ngo-democratizing-tourism-via-web3-9ihr-naighba.vercel.app/founders"
        />
      </Helmet>
      <div className="founders-thq-hero-elm">
        <div className="founders-thq-heading-elm1">
          <div id="notifcation" className="founders-thq-notification-elm">
            <Announcement rootClassName="announcementroot-class-name5"></Announcement>
          </div>
          <nav className="founders-thq-navbar-elm">
            <div className="founders-thq-desktop-elm">
              <Link to="/" className="founders-navlink1">
                <div className="founders-thq-main-elm">
                  <div className="founders-thq-branding-elm">
                    <img
                      alt="pastedImage"
                      src="/logo/romania_logo.svg"
                      className="founders-thq-romania-elm"
                    />
                  </div>
                  <div className="founders-thq-links-elm1">
                    <span className="founders-thq-link-elm1 link">
                      Features
                    </span>
                    <span className="founders-thq-link-elm2 link">
                      How it works
                    </span>
                    <span className="founders-thq-link-elm3 link">Prices</span>
                    <span className="founders-thq-link-elm4 link">Contact</span>
                  </div>
                </div>
              </Link>
              <Link to="/ambassadors" className="founders-navlink2">
                <div className="founders-thq-contribute-elm">
                  <span className="founders-thq-sign-up-elm">Ambassadors</span>
                  <div className="founders-container11">
                    <svg viewBox="0 0 1024 1024" className="founders-icon10">
                      <path d="M512 950.857c-9.143 0-18.286-3.429-25.143-10.286l-356.571-344c-4.571-4-130.286-118.857-130.286-256 0-167.429 102.286-267.429 273.143-267.429 100 0 193.714 78.857 238.857 123.429 45.143-44.571 138.857-123.429 238.857-123.429 170.857 0 273.143 100 273.143 267.429 0 137.143-125.714 252-130.857 257.143l-356 342.857c-6.857 6.857-16 10.286-25.143 10.286z"></path>
                    </svg>
                  </div>
                </div>
              </Link>
              <img
                id="open-mobile-menu"
                alt="pastedImage"
                src="/pastedimage-8o98.svg"
                className="founders-thq-hamburger-menu-elm"
              />
            </div>
            <div id="mobile-menu" className="founders-thq-mobile-elm">
              <div className="founders-thq-top-elm">
                <img
                  alt="image"
                  src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
                  className="founders-image1"
                />
                <svg
                  id="close-mobile-menu"
                  viewBox="0 0 1024 1024"
                  className="founders-icon12"
                >
                  <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                </svg>
              </div>
              <div className="founders-thq-links-elm2">
                <Link to="/" className="founders-navlink3">
                  Features
                </Link>
                <Link to="/" className="founders-navlink4">
                  How it works
                </Link>
                <Link to="/" className="founders-navlink5">
                  Prices
                </Link>
                <Link to="/" className="founders-navlink6">
                  Contact
                </Link>
                <div className="founders-thq-buttons-elm">
                  <Link to="/" className="founders-navlink7">
                    <div className="founders-thq-btn-elm1">
                      <span className="founders-text10">Log in</span>
                    </div>
                  </Link>
                  <Link to="/" className="founders-navlink8">
                    <div className="founders-thq-btn-elm2">
                      <span className="founders-text11">Sign up</span>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div>
              <div className="founders-container13">
                <Script
                  html={`<script>
(function() {
  var mobileMenu = document.querySelector("#mobile-menu");
  var closeButton = document.querySelector("#close-mobile-menu");
  var openButton = document.querySelector("#open-mobile-menu");
  if (mobileMenu && closeButton && openButton) {
    openButton.addEventListener("click", function() {
      mobileMenu.style.transform = "translateX(0%)";
    });
    closeButton.addEventListener("click", function() {
      mobileMenu.style.transform = "translateX(100%)";
    });
  }
})();
</script>`}
                ></Script>
              </div>
            </div>
          </nav>
        </div>
        <div className="founders-thq-team-members-elm">
          <div className="founders-thq-title-elm">
            <div className="founders-container14">
              <span className="founders-text12 index_black">@Romania</span>
              <div className="founders-container15"></div>
              <span className="founders-text13 index_black">
                Non-governmental organization
              </span>
              <span className="founders-text14 index_black">NGO</span>
            </div>
            <h2 className="founders-thq-heading-elm2 heading">
              <span>Team</span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
            </h2>
          </div>
          <div className="founders-container16">
            <div className="founders-container17">
              <div className="founders-thq-n1-elm1">
                <img
                  alt="image"
                  src="/team/sabin-1500h.png"
                  className="founders-image2"
                />
                <div className="founders-thq-container-elm1">
                  <div className="founders-container18">
                    <div className="founders-container19">
                      <a
                        href="https://www.linkedin.com/in/sabinstanescu/"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="founders-link1"
                      >
                        <svg
                          viewBox="0 0 877.7142857142857 1024"
                          className="founders-icon14"
                        >
                          <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                        </svg>
                      </a>
                      <h1 className="founders-text18">
                        <span>Sabin</span>
                      </h1>
                    </div>
                    <div className="founders-container20">
                      <span className="founders-text20">
                        President and Co-founder
                      </span>
                    </div>
                  </div>
                  <span className="founders-text21">
                    <span>
                      Professional world traveler and tech enthusiast. Guinness
                      World Record holder who has journeyed to over 60 countries
                      to research tourist destinations.
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                    <span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ' ',
                        }}
                      />
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="founders-container21">
              <div className="founders-thq-n1-elm2">
                <img
                  alt="image"
                  src="/team/iulian-1500h.png"
                  className="founders-image3"
                />
                <div className="founders-thq-container-elm2">
                  <div className="founders-container22">
                    <div className="founders-container23">
                      <a
                        href="https://www.linkedin.com/in/iulian/"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="founders-link2"
                      >
                        <svg
                          viewBox="0 0 877.7142857142857 1024"
                          className="founders-icon16"
                        >
                          <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                        </svg>
                      </a>
                      <h1 className="founders-text24">Iulian</h1>
                    </div>
                    <div className="founders-container24">
                      <span className="founders-text25">Co-founder</span>
                    </div>
                  </div>
                  <span className="founders-text26">
                    Experienced content creator and adventurer. Has attended
                    some of the most prestigious racing and art events.
                    Considers Romania the best place on Earth.
                  </span>
                </div>
              </div>
            </div>
            <div className="founders-container25">
              <div className="founders-thq-n1-elm3">
                <img
                  alt="image"
                  src="/team/jay-1500h.png"
                  className="founders-image4"
                />
                <div className="founders-thq-container-elm3">
                  <div className="founders-container26">
                    <div className="founders-container27">
                      <a
                        href="https://www.linkedin.com/in/eduardsmaranda/"
                        target="_blank"
                        rel="noreferrer noopener"
                        className="founders-link3"
                      >
                        <svg
                          viewBox="0 0 877.7142857142857 1024"
                          className="founders-icon18"
                        >
                          <path d="M135.429 808h132v-396.571h-132v396.571zM276 289.143c-0.571-38.857-28.571-68.571-73.714-68.571s-74.857 29.714-74.857 68.571c0 37.714 28.571 68.571 73.143 68.571h0.571c46.286 0 74.857-30.857 74.857-68.571zM610.286 808h132v-227.429c0-121.714-65.143-178.286-152-178.286-70.857 0-102.286 39.429-119.429 66.857h1.143v-57.714h-132s1.714 37.143 0 396.571v0h132v-221.714c0-11.429 0.571-23.429 4-32 9.714-23.429 31.429-48 68-48 47.429 0 66.286 36 66.286 89.714v212zM877.714 237.714v548.571c0 90.857-73.714 164.571-164.571 164.571h-548.571c-90.857 0-164.571-73.714-164.571-164.571v-548.571c0-90.857 73.714-164.571 164.571-164.571h548.571c90.857 0 164.571 73.714 164.571 164.571z"></path>
                        </svg>
                      </a>
                      <h1 className="founders-text27">Eduard</h1>
                    </div>
                    <div className="founders-container28">
                      <span className="founders-text28">Co-founder</span>
                    </div>
                  </div>
                  <span className="founders-text29">
                    <span className="founders-text30">
                      Architecture graduate and self-taught creative who builds,
                      writes and designs. Has developed his problem-solving
                      skillset in an international environment.
                    </span>
                    <br></br>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img alt="image" src="/map.svg" className="founders-thq-map-elm" />
        <img
          alt="image"
          src="/compressed-4500w.gif"
          className="founders-thq-gif-elm"
        />
      </div>
      <Footer rootClassName="footerroot-class-name"></Footer>
    </div>
  )
}

export default Founders
